import React, { useEffect, useState } from "react";
import { store } from "react-notifications-component";
import { useSelector } from "react-redux";
import { State } from "../../app/store";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { isAddToBasketInfoMessage } from "../../app/utils/apiInfoMessages";

interface IProps {
  info: string[] | null;
  onHide: Function;
}

const InfoAlerts: React.FC<IProps> = ({ info, onHide }: IProps) => {
  const showPopupAfterAddTicket = useSelector((state: State) => state.config.configuration.popupAfterAddTicket);
  const [infoAlertDisplayed, setInfoAlertDisplayed] = useState(false);
  const { t } = useTranslation();
  const location = useLocation();

  // Wyczyść komunikaty o dodaniu do koszyka automatycznie gdy jesteśmy w koszyku
  useEffect(() => {
    const isInBasket = location.pathname.includes("/finalize");
    const isAddToBasketMessage = info?.some(isAddToBasketInfoMessage);

    if (isInBasket && isAddToBasketMessage) {
      onHide();
    }
  }, [info, location.pathname, onHide]);

  const showAlert = () => {
    // Nie wyświetlaj komunikatów o dodaniu do koszyka w koszyku
    const isInBasket = location.pathname.includes("/finalize");
    const isAddToBasketMessage = info?.some(isAddToBasketInfoMessage);

    if (isInBasket && isAddToBasketMessage) {
      return false;
    }

    if (showPopupAfterAddTicket) {
      return false;
    } else {
      return true;
    }
  };

  useEffect(() => {
    const infoNotifications = () => {
      const otherInfo = (info ?? []).filter((item) => !isAddToBasketInfoMessage(item));
      if (otherInfo.length === 0) return;

      const infoText = otherInfo.reduce((acc: string, item: string) => `${acc} ${item}`, "");

      if (!infoAlertDisplayed) {
        store.addNotification({
          title: t("informacja"),
          message: Boolean(infoText) ? infoText : "",
          type: "info",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 5000,
            onScreen: true,
            showIcon: true,
          },
          onRemoval: () => {
            onHide();
            setInfoAlertDisplayed(false);
          },
        });
        setInfoAlertDisplayed(true);
      }
    };

    if (info && showAlert()) {
      infoNotifications();
    }
    //eslint-disable-next-line
  }, [info]);
  return <React.Fragment></React.Fragment>;
};

export default InfoAlerts;
